module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kaltbrunn-7b721c38c2e6ec49bef3b7e0f63ef304.png";